import { useTranslation } from 'react-i18next';
import './FillerBox.css';
import { FaPeopleArrows } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";

const FillerBox = () => {
    const { t } = useTranslation('common');
    const nav = useNavigate();

    return (
        <div className="filler-box-cont" onClick={() => nav("/peertopeer")}>
            <div className="filler-box-text">
                <div className="peertopeer-publicity-title">
                    {t('peertopeer_publicity_title')}
                </div>
                <div>{t('peertopeer_publicity_description')}</div>
            </div>
            <div className="filler-box-icon">
                <FaPeopleArrows size={100} className="sidebar-icon" />
            </div>
        </div>
    );
};

export default FillerBox;